import { BaseOwnerEntity } from "./baseOwnerEntity";



export class VoipInternalModel extends BaseOwnerEntity {
  id?: number;
  voipId?: number;
  name?: string;
  userName?: string;
  password?: string;
  status?: number;
  apiUserName?: string;
  apiPassword?: string;
  internalNo?: string;
  internalNoForStartingCall?: string;
  callType?: string;
}